module.exports = __webpack_public_path__ + "static/img/car_mg_zsev_mce.e695d7d7.png";